

export const ReportTypes = Object.freeze({
    WorkItemSummaryReport: "Work Item Summary",
    IdrStatusReport: "IDR Status",
    WeatherSummaryReport: "Weather Summary Report",
    IdrExport: "IDR Export"
});
